module.exports = __webpack_public_path__ + "img/YG.258ce906.png";